module.exports = __webpack_public_path__ + "img/comment01.8527315c.png";